/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssetResponse,
  CreateAssetDto,
  DeleteAssetDto,
  ReadAssetDto,
  UpdateAssetCostValueDto,
  UpdateAssetDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Assets<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags assets
   * @name Create
   * @request POST:/assets
   * @secure
   */
  create = (data: CreateAssetDto, params: RequestParams = {}) =>
    this.request<AssetResponse, any>({
      path: `/assets`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assets
   * @name Update
   * @request PATCH:/assets
   * @secure
   */
  update = (data: UpdateAssetDto, params: RequestParams = {}) =>
    this.request<AssetResponse, any>({
      path: `/assets`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assets
   * @name FindAll
   * @request POST:/assets/find
   * @secure
   */
  findAll = (data: ReadAssetDto, params: RequestParams = {}) =>
    this.request<AssetResponse[], any>({
      path: `/assets/find`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assets
   * @name FindOne
   * @request GET:/assets/{id}
   * @secure
   */
  findOne = (id: string, params: RequestParams = {}) =>
    this.request<AssetResponse, any>({
      path: `/assets/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assets
   * @name UpdateCostValue
   * @request POST:/assets/updateCostValue
   * @secure
   */
  updateCostValue = (
    data: UpdateAssetCostValueDto,
    params: RequestParams = {},
  ) =>
    this.request<AssetResponse, any>({
      path: `/assets/updateCostValue`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags assets
   * @name Remove
   * @request POST:/assets/delete
   * @secure
   */
  remove = (data: DeleteAssetDto, params: RequestParams = {}) =>
    this.request<AssetResponse, any>({
      path: `/assets/delete`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
